export var PasswordResetFlowEnum;
(function (PasswordResetFlowEnum) {
    PasswordResetFlowEnum["FORGOT_PASSWORD"] = "FORGOT_PASSWORD";
    PasswordResetFlowEnum["USER_PROFILE"] = "USER_PROFILE";
})(PasswordResetFlowEnum || (PasswordResetFlowEnum = {}));
//# sourceMappingURL=PasswordResetFlowEnum.js.map